<mat-list>
  <mat-list-item *ngFor="let item of messageList" class="list-item">
    <div class="time">
      {{item.time}}
    </div>
    <div class="message" [ngClass]="{'error': item.state==='error', 'warning': item.state==='warning'}">
      {{item.message}}
    </div>
  </mat-list-item>
</mat-list>
